<div class="main-tab">
  <ng-content></ng-content>
</div>
